import {useQuery} from 'react-query';
import {getListLoanType} from './getListLoanType';

const useGetListLoanType = (isDirect: boolean) => {
  const {data, isLoading} = useQuery({
    queryKey: ['list-loan-type', isDirect],
    queryFn: () => getListLoanType(isDirect),
  });

  return {data, isLoading};
};

export default useGetListLoanType;
